// Nothing is hidden: filtering would leave a section's totals covering lines
// gone from the screen. The matching lines are highlighted, the unrelated ones
// faded, and a section carrying a match is never faded — it is the path to it.
import { plainText } from "./formatting"

// Accents and case folded away: "demarrage" must find "démarrage".
export const fold = value =>
  plainText(String(value || ""))
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")

const haystackOf = node => [
  node.description,
  node.ref_product_distrib,
  node.unit,
].filter(Boolean).map(fold).join(" ")

export const nodeMatches = (node, needle) =>
  !!needle && haystackOf(node).includes(needle)

export const collectMatches = (sections, query) => {
  const needle  = fold(query)
  const matches = new Set()
  const relevant = new Set()
  const ordered = []

  if (!needle) return { matches, relevant, ordered, needle }

  const walk = (nodes, ancestors) => {
    ;(nodes || []).forEach(node => {
      if (node._destroy) return

      if (nodeMatches(node, needle)) {
        matches.add(node._uid)
        ordered.push(node._uid)
        relevant.add(node._uid)
        ancestors.forEach(uid => relevant.add(uid))
      }
      if (node.children) walk(node.children, [...ancestors, node._uid])
    })
  }

  walk(sections, [])
  return { matches, relevant, ordered, needle }
}
